import {
	type inferParserType,
	parseAsInteger,
	parseAsString,
	parseAsStringLiteral,
	useQueryStates,
} from 'nuqs'

const parsers = {
	activeYear: parseAsInteger.withDefault(new Date().getFullYear()),
	searchTerms: parseAsString,
	sortOrder: parseAsStringLiteral(['asc', 'desc']).withDefault('desc'),
}

export type InvoicesFilters = inferParserType<typeof parsers>

export const useInvoicesFilters = () => {
	return useQueryStates(parsers)
}
